<template>
  <div class="step">
    <!-- Errored Steps-->
    <p v-if="isError" class="follow-up-step has-text-danger">
      An <strong>Error:</strong> '{{ step.error_message }}' occurred on <strong>{{ formatDate(step.errored_at) }}</strong>
    </p>

    <!-- Completed And Pending Steps-->
    <p v-else :class="['follow-up-step', {'has-text-light': isCompleted}]">
      {{ isEmailType ? "An" : "A" }}

      <!-- Task-->
      <b-tooltip
        v-if="isTaskType"
        :label="step.description"
        position="is-right"
        multilined
      >
        <strong class="has-text-primary">{{ typeLabel }}</strong>
      </b-tooltip>

      <!-- Text or Email-->
      <b-tooltip
        v-else
        :label="step.body | stripTags"
        position="is-right"
        multilined
      >
        <strong class="has-text-primary">{{ typeLabel }}</strong>
      </b-tooltip>

      <!-- Completed Steps-->
      <template v-if="isCompleted">
        <template v-if="isTaskType">({{ step.label }}) was created on</template>
        <template v-else-if="isEmailType">with subject "{{ step.subject }}" was sent on</template>
        <template v-else>was sent on</template>

        <strong>{{ formatDate(step.completed_at) }}</strong>
      </template>

      <!-- Pending Steps-->
      <template v-else>
        <template v-if="isTaskType">({{ step.label }}) will be created on</template>
        <template v-else-if="isEmailType">with subject "{{ step.subject }}" is scheduled to be sent on</template>
        <template v-else>is scheduled to be sent on</template>

        {{ formatDate(step.queueable_at) }}
      </template>
    </p>

  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import dates from "../../../services/dates";

export default {
  name: "FollowUpViewInfoStep",
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isError() {
      return this.step.status === ENUMS.QueueableStatusEnum.Errored.value;
    },
    isCompleted() {
      return this.step.status === ENUMS.QueueableStatusEnum.Completed.value;
    },
    isEmailType() {
      return this.step.type === ENUMS.FollowUpSequenceStepTypeEnum.Email.value;
    },
    isTaskType() {
      return this.step.type === ENUMS.FollowUpSequenceStepTypeEnum.Task.value;
    },
    typeLabel() {
      return this.$utils.newGetEnumLabel(this.step.type, ENUMS.FollowUpSequenceStepTypeEnum);
    },
  },
  methods: {
    formatDate(date) {
      if(!date) return '--';

      return dates.formatAsDate(date) + " @ " + dates.formatAsTime(date);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.label {
  margin-bottom: 6px;
}

.step {
  margin-top: 10px;
}

.follow-up-step {
  line-height: 1.3;
  word-break: break-word;
}
</style>
